import react, { useEffect, useState } from "react";
import { addScriptFile, loggerStore, removeScriptFile } from "./utils";
import { useNavigate } from "react-router";
import configData from "../Config";
import { apis } from "../services/apiService";

const IngenicoEnach = () => {
  // console.log("enachReqData--------", enachReqData);
  let currentDate = new Date();
  let day = currentDate.getDate();
  let month = currentDate.getMonth();
  let year = currentDate.getFullYear();
  // console.log("abc--------", currentDate);
  const navigate = useNavigate();
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  // useEffect(() => {
  //   // Define the CDN script URLs which we want to load
  //   const scriptUrls = [
  //     "https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js",
  //     "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js",
  //     // "https://code.jquery.com/jquery-3.7.1.min.js",
  //     // Add more script URLs as needed
  //   ];
  //   // Wait for all scripts to load
  //   Promise.all(addScriptFile(scriptUrls))
  //     .then(() => {
  //       setTimeout(() => {
  //         setScriptsLoaded(true);
  //       }, 5000);
  //     })
  //     .catch((error) => {
  //       console.error("Error loading scripts:", error);
  //     });
  //   // Clean up the script elements when the component unmounts
  //   // return () => removeScriptFile(scriptUrls);
  // }, []);

  const navigateOnSuccessHandler = async (res, respFrom = "") => {
    try {
      let reqData = res;
      reqData.id = res?.merchantTransactionIdentifier;
      let resp = await apis.postApi(
        configData.API_URL + "Enach/CheckENACHStatus",
        reqData
      );
      let result = await resp?.json();
      if (resp?.status === 200) {
        if (respFrom === "success") {
          loggerStore(
            res?.merchantTransactionIdentifier,
            `enach CheckENACHStatus api call of success block = ${JSON?.stringify(
              res
            )}`,
            "information"
          );
        } else if (respFrom === "initiated") {
          loggerStore(
            res?.merchantTransactionIdentifier,
            `enach CheckENACHStatus api call of initiated block = ${JSON?.stringify(
              res
            )}`,
            "information"
          );
        } else if (respFrom === "error") {
          loggerStore(
            res?.merchantTransactionIdentifier,
            `enach CheckENACHStatus api call of error block = ${JSON?.stringify(
              res
            )}`,
            "information"
          );
        }
        navigate("/complete-kyc", {
          state: { AppId: reqData?.merchantTransactionIdentifier },
        });
      }
    } catch (error) {
      loggerStore(
        res?.merchantTransactionIdentifier,
        `enach CheckENACHStatus api call error = ${JSON?.stringify(error)}`,
        "error"
      );
      // console.log("error---", error);
    }
  };

  function handleResponse(res) {
    if (
      typeof res != "undefined" &&
      typeof res.paymentMethod != "undefined" &&
      typeof res.paymentMethod.paymentTransaction != "undefined" &&
      typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" &&
      res.paymentMethod.paymentTransaction.statusCode == "0300"
    ) {
      // success block
      // console.log("success block----", res);
      navigateOnSuccessHandler(res, "success");
      loggerStore(
        res?.merchantTransactionIdentifier,
        `enach success response = ${JSON?.stringify(res)}`,
        "Information"
      );
      // // console.log("success block--json data--", res.json());
      // console.log("success block--json stringify--", JSON.stringify(res));
    } else if (
      typeof res != "undefined" &&
      typeof res.paymentMethod != "undefined" &&
      typeof res.paymentMethod.paymentTransaction != "undefined" &&
      typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" &&
      res.paymentMethod.paymentTransaction.statusCode == "0398"
    ) {
      // initiated block
      // console.log("initiated block----", res);
      navigateOnSuccessHandler(res, "initiated");
      loggerStore(
        res?.merchantTransactionIdentifier,
        `enach initiated response = ${JSON?.stringify(res)}`,
        "Information"
      );
    } else {
      // error block
      // console.log("error block----", res);
      navigateOnSuccessHandler(res, "error");
      loggerStore(
        res?.merchantTransactionIdentifier,
        `enach error response = ${JSON?.stringify(res)}`,
        "error"
      );
      let errorMsg =
        res?.stringResponse?.split("|")?.[2] || "We are facing some issue";
      alert(errorMsg);
    }
  }

  const openEnachScreen = (enachReqData) => {
    let reqJson = {
      features: {
        enableAbortResponse: true,
        enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
        enableExpressPay: true,
        enableMerTxnDetails: true,
        siDetailsAtMerchantEnd: true,
        enableSI: true,
        showPGResponseMsg: true,
        payDetailsAtMerchantEnd: true,
      },
      consumerData: {
        deviceId: enachReqData?.deviceId, //possible values "WEBSH1" or "WEBSH2"
        token: enachReqData?.token,
        returnUrl: navigate("/pending-enach"),
        responseHandler: handleResponse,
        paymentMode: enachReqData?.payableMode,
        merchantLogoUrl: "/assets/logoTygerCapital.svg", //provided merchant logo will be displayed
        merchantId: enachReqData?.merchantId,
        currency: enachReqData?.currency,
        consumerId: enachReqData?.consumerId, //Your unique consumer identifier to register a eMandate/eNACH
        consumerMobileNo: enachReqData?.consumerMobileNo,
        consumerEmailId: enachReqData?.consumerEmailId,
        txnId: enachReqData?.txnId, //Unique merchant transaction ID
        items: [enachReqData?.items],
        customStyle: {
          PRIMARY_COLOR_CODE: "#45beaa", //merchant primary color code
          SECONDARY_COLOR_CODE: "#FFFFFF", //provide merchant's suitable color code
          BUTTON_COLOR_CODE_1: "#2d8c8c", //merchant's button background color code
          BUTTON_COLOR_CODE_2: "#FFFFFF", //provide merchant's suitable color code for button text
        },
        accountNo: enachReqData?.accountNo, //Pass this if accountNo is captured at merchant side for eMandate/eNACH
        accountHolderName: enachReqData?.accountHolderName, //Pass this if accountHolderName is captured at merchant side for ICICI eMandate & eNACH registration this is mandatory field, if not passed from merchant Customer need to enter in Checkout UI.
        ifscCode: enachReqData?.ifscCode, //Pass this if ifscCode is captured at merchant side.
        accountType: enachReqData?.accountType, //Required for eNACH registration this is mandatory field
        debitStartDate: enachReqData?.debitStartDate,
        debitEndDate: enachReqData?.debitEndDate,
        maxAmount: enachReqData?.maxAmount,
        amountType: enachReqData?.amountType,
        frequency: enachReqData?.frequency, //  Available options DAIL, WEEK, MNTH, QURT, MIAN, YEAR, BIMN and ADHO
        cartDescription: enachReqData?.mandateRegistrationNumber,
        bankCode: enachReqData?.bankCode,
      },
    };
    loggerStore(
      enachReqData?.consumerId,
      `enach request = ${JSON.stringify(reqJson)}`,
      "Information"
    );
    console.log("reqJson---", reqJson);
    window?.$?.pnCheckout(reqJson);
    if (reqJson?.features?.enableNewWindowFlow) {
      window?.$?.pnCheckoutShared?.openNewWindow();
      loggerStore(
        enachReqData?.consumerId,
        `enach modal opened = ${JSON.stringify(reqJson)}`,
        "Information"
      );
    }
  };

  return { openEnachScreen };
};

export default IngenicoEnach;
